import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var twitter = require('twitter-text');

var LLTextArea = /*#__PURE__*/function (_Component) {
  _inherits(LLTextArea, _Component);

  var _super = _createSuper(LLTextArea);

  function LLTextArea() {
    var _this;

    _classCallCheck(this, LLTextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "calculateCharacterCount", function () {
      if (_this.props.lengthAlgo === 'twitter') {
        return _this.props.maxCharacters - twitter.getTweetLength(_this.props.value);
      }

      return _this.props.maxCharacters - _this.props.value.length;
    });

    return _this;
  }

  _createClass(LLTextArea, [{
    key: "render",
    value: function render() {
      var charCounter = null;

      if (this.props.maxCharacters > 0 && !this.props.hideCharacterCounter) {
        charCounter = /*#__PURE__*/React.createElement("small", {
          style: {
            position: 'relative',
            top: '-30px',
            left: '90%',
            textAlign: 'center'
          }
        }, this.calculateCharacterCount().toString());
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
        id: this.props.id,
        style: this.props.style,
        floatingLabelText: this.props.placeholder,
        type: this.props.type,
        value: this.props.value,
        onChange: this.props.onChange,
        multiLine: true,
        rows: 3
      }), charCounter);
    }
  }]);

  return LLTextArea;
}(Component);

_defineProperty(LLTextArea, "propTypes", {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  maxCharacters: PropTypes.number,
  lengthAlgo: PropTypes.string,
  id: PropTypes.string,
  hideCharacterCounter: PropTypes.bool
});

_defineProperty(LLTextArea, "defaultProps", {
  placeholder: '',
  type: null,
  style: {},
  value: '',
  onChange: null,
  id: null,
  maxCharacters: -1,
  lengthAlgo: 'vanilla',
  hideCharacterCounter: false
});

export { LLTextArea as default };